const ClevinooSubscriptionSkus = new Set(['CLV-SUB-MT', 'CLV-SUB-YR']);
const ClevinooSubscriptionKey = '_clevinoo_subscription_key';

async function ensureClevinooSubscriptionKeys() {
  const cart = await fetch(`${routes.cart_url}.js`, { headers: { Accept: 'application/json' } })
    .then((response) => {
      if (!response.ok) throw new Error('Unable to load cart.');
      return response.json();
    });

  const subscriptionLines = cart.items.filter((item) => ClevinooSubscriptionSkus.has(item.sku));
  for (const item of subscriptionLines) {
    if (item.properties?.[ClevinooSubscriptionKey]) continue;

    const response = await fetch(routes.cart_change_url, {
      ...fetchConfig(),
        body: JSON.stringify({
          id: item.key,
          quantity: item.quantity,
          properties: {
          ...item.properties,
          [ClevinooSubscriptionKey]: crypto.randomUUID(),
        },
      }),
    });
    if (!response.ok) throw new Error('Unable to update subscription line.');
  }
}

document.addEventListener('submit', (event) => {
  const form = event.target;
  const submitter = event.submitter;
  if (!(form instanceof HTMLFormElement) || submitter?.name !== 'checkout') return;

  event.preventDefault();
  void ensureClevinooSubscriptionKeys()
    .then(() => {
      const checkout = document.createElement('input');
      checkout.type = 'hidden';
      checkout.name = 'checkout';
      checkout.value = submitter.value || 'Checkout';
      form.append(checkout);
      HTMLFormElement.prototype.submit.call(form);
    })
    .catch((error) => {
      console.error(error);
      const errorTarget = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
      if (errorTarget && window.cartStrings?.error) errorTarget.textContent = window.cartStrings.error;
    });
}, true);
